import { PrivateInterceptor } from "../../Base/interceptors/PrivateInterceptor";

//LISTADO SOLICITUDES PARA APROBACION
export const getNotasCredito = async () => {
    const respuesta = await PrivateInterceptor('imex/NotasCredito/AprobacionNotasCredito', 'GET')
    return respuesta
}

export const verifyPassword = async (data) => {
    const respuesta =  await PrivateInterceptor('imex/NotasCredito/VerificarPasswordWeb', 'PUT',data);
    return respuesta;
};
  